export default {
  aboutUs: 'عطارة أون لاين موقع متخصص لبيع التوابل والبهارات والبقوليات والمكسرات والمنتجات التجميلية وجميع انواع المكملات الغذائية. بالاضافة الي العديد من النصائح الطبية التي تهتم بالصحه العامة وكيفية أستخدام العطارة باساليب تضمن صحه أفضل لحياة أفضل . '
}
